<template>
  <div class="d-flex align-items-center">
    <label :for="id" class="pr-3">{{ $t("global.page") }}</label>
    <div>
      <select :id="id" :value="pagination.index" v-on:change="onPageChange" class="form-control">
        <option v-for="option in pages" v-bind:key="option" v-bind:value="option - 1">
          {{ option }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { uniqueId } from "lodash-es";

export default {
  name: "TablePagination",
  props: {
    name: String,
    pages: Number,
    pagination: Object,
  },
  setup(props, { emit }) {
    const id = uniqueId(props.name ? `${props.name?.toLowerCase()}-page-input-` : "page-input-");
    const onPageChange = (event) => {
      emit("update:pagination", { index: Number(event.target.value), size: props.pagination.size });
    };

    return {
      id,
      onPageChange,
    };
  },
};
</script>

<style lang="scss" scoped>
label {
  display: inherit;
  margin-bottom: 0;
}
</style>
